export class PermissionsRequest {
  public canRead: boolean;
  public canCreate: boolean;
  public canUpdate: boolean;
  public canDelete: boolean;
}
